<template>
  <v-row>
    <v-col class="mt-2" cols="12" offset-lg="1" lg="10">
      <v-breadcrumbs :items="breadcrumbs" divider=">" class="pl-1 pb-3" />
      <v-card>
        <v-card-title class="theme">
          <v-icon class="white--text">place</v-icon>
          <span class="headline ml-2 white--text">Edit office location</span>
          <v-spacer />
          <v-btn depressed @click="dialog = true" class="error rounded-sm"
            >delete</v-btn
          >
        </v-card-title>
        <v-divider />
        <v-card-text>
          <v-form ref="form">
            <v-container>
              <v-row v-if="location">
                <v-col cols="12" md="5">
                  <v-text-field
                    label="Office Name*"
                    persistent-hint
                    :rules="[validationRules.required]"
                    :disabled="tempDisable"
                    hint="Name of the office e.g. Development Center - Poland"
                    v-model="location.title"
                  />
                </v-col>
                <v-col class="pa-4" cols="12" md="7">
                  <div class="pt-3 grey--text">
                    Provide a name to the office location
                  </div>
                </v-col>

                <v-col cols="12" md="5">
                  <v-autocomplete
                    label="Country *"
                    persistent-hint
                    hint="Coutry for the office location"
                    :items="countries"
                    :disabled="tempDisable"
                    item-text="name"
                    item-value="name"
                    :rules="[validationRules.required]"
                    v-model="location.country"
                  />
                </v-col>
                <v-col class="pa-4" cols="12" md="7">
                  <div class="pt-3 grey--text">
                    Country where this office is located
                  </div>
                </v-col>

                <v-col cols="12" md="5">
                  <v-text-field
                    label="Contact Email"
                    persistent-hint
                    :disabled="tempDisable"
                    :rules="[validationRules.email]"
                    v-model="location.contact_email"
                  />
                </v-col>
                <v-col class="pa-4" cols="12" md="7">
                  <div class="pt-3 grey--text">
                    Contact email for the company.
                  </div>
                </v-col>

                <v-col cols="12" md="2">
                  <v-autocomplete
                    label="Country code"
                    persistent-hint
                    hint="Required for ISD code"
                    :items="countries"
                    :disabled="tempDisable"
                    :item-text="isdCodeName"
                    :return-object="true"
                    v-model="location.contact_isd"
                  />
                </v-col>
                <v-col cols="12" md="3">
                  <v-text-field
                    label="Phone / Mobile number"
                    persistent-hint
                    hint="eg 90000000"
                    type="tel"
                    :disabled="tempDisable"
                    validate-on-blur
                    :rules="[phoneValidationRule]"
                    v-model="location.contact_phone"
                  />
                </v-col>
                <v-col class="pa-4" cols="12" md="7">
                  <div class="pt-3 grey--text">
                    First select the country and then provide the phone number
                    to contact this location.
                  </div>
                </v-col>

                <v-col cols="12" md="5">
                  <v-text-field
                    label="Address Line 1"
                    persistent-hint
                    :disabled="tempDisable"
                    v-model="location.line_1"
                  />
                </v-col>
                <v-col cols="12" md="7" />

                <v-col cols="12" md="5">
                  <v-text-field
                    label="Address Line 2"
                    persistent-hint
                    :disabled="tempDisable"
                    v-model="location.line_2"
                  />
                </v-col>
                <v-col cols="12" md="7" />

                <v-col cols="12" md="5">
                  <v-text-field
                    :disabled="tempDisable"
                    label="City"
                    persistent-hint
                    :rules="[validationRules.required]"
                    v-model="location.city"
                  />
                </v-col>
                <v-col cols="12" md="7" />

                <v-col cols="12" md="5">
                  <v-text-field
                    :disabled="tempDisable"
                    label="State"
                    persistent-hint
                    v-model="location.state"
                  />
                </v-col>
                <v-col cols="12" md="7" />

                <v-col cols="12" md="5">
                  <v-text-field
                    label="PostCode"
                    :disabled="tempDisable"
                    persistent-hint
                    v-model="location.post_code"
                  />
                </v-col>
                <v-col cols="12" md="7" />
                <v-col cols="12" md="5">
                  <v-textarea
                    label="Additional information"
                    :disabled="tempDisable"
                    persistent-hint
                    rows="3"
                    v-model="location.description"
                  />
                </v-col>
                <v-col class="px-4 pt-5" cols="12" md="7">
                  <div class="pt-4 grey--text">
                    Any additional information for your reference. This will not
                    be displayed anywhere else.
                  </div>
                </v-col>
              </v-row>
              <v-btn
                depressed
                class="save rounded-sm white--text ml-0"
                @click="save"
                >save</v-btn
              >
            </v-container>
          </v-form>
        </v-card-text>
      </v-card>
    </v-col>

    <v-dialog v-model="dialog" persistent max-width="400">
      <v-card>
        <v-card-title class="headline pt-4">
          <v-spacer />
          <span>Are you sure?</span>
          <v-spacer />
        </v-card-title>
        <v-divider />
        <v-card-text class="my-3 text-center"
          >You will not be able to undo this operation.</v-card-text
        >
        <v-divider />
        <v-card-actions>
          <v-btn color="success" text @click="dialog = !dialog">cancel</v-btn>
          <v-spacer />
          <v-btn color="error" text @click="deleteAddress">delete</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar v-model="snackbar" :bottom="true" :right="true">
      {{ snackbarMessage }}
      <v-btn color="pink" text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
  </v-row>
</template>
<script>
import libphonenumber from "google-libphonenumber";
import { mapGetters } from "vuex";

import { Actions } from "@/views/actions";
import { Breadcrumbs } from "@/views/breadcrumbs";
import { Component } from "@/views/component";
import { Constants } from "@/views/constants";

export default {
  name: Component.Protected.Company.Locations.Edit,
  data: () => ({
    breadcrumbs: Breadcrumbs.Locations.Edit,
    tempDisable: false,
    location: {
      title: "",
      type: "Office",
      city: "",
      state: "",
      line_1: "",
      line_2: "",
      country: "",
      post_code: "",
      description: "",
      contact_email: "",
      contact_phone: "",
      contact_isd: "",
    },
    phoneValidator: null,
    dialog: false,
  }),
  computed: {
    ...mapGetters(["countries", "userInfo"]),
    phoneValidationRule() {
      if (!this.location.contact_isd && !this.location.contact_phone)
        return true;
      // Both ISD and Num should be filled
      if (this.location.contact_isd && !this.location.contact_phone)
        return Constants.PhoneNumber.Messages.Error.Required;
      if (!this.location.contact_isd && this.location.contact_phone)
        return Constants.PhoneNumber.Messages.Error.SelectISD;
      if (isNaN(this.location.contact_phone))
        return Constants.PhoneNumber.Messages.Error.InvalidFormat;
      if (this.location.contact_phone && this.location.contact_phone.length < 8)
        return Constants.PhoneNumber.Messages.Error.InvalidFormat;
      if (!this.location.contact_phone || !this.location.contact_isd.code)
        return Constants.PhoneNumber.Messages.Error.InvalidCountryCode;

      const num = this.phoneValidator.parseAndKeepRawInput(
        this.location.contact_phone,
        this.location.contact_isd.code
      );
      if (!num) return Constants.PhoneNumber.Messages.Error.InvalidFormat;
      if (this.phoneValidator.isValidNumber(num)) return true;
      return Constants.PhoneNumber.Messages.Error.InvalidCountryCode;
    },
  },
  methods: {
    isdCodeName(c) {
      if (c) return `${c.dial_code} - ${c.name}`;
    },
    save() {
      if (this.$refs.form.validate()) {
        this.tempDisable = true;

        let data = {
          ...this.location,
          contact_isd: this.location.contact_isd
            ? this.location.contact_isd.dial_code
            : "",
        };
        let dispatchData = { id: this.$route.params.id, data: data };
        this.$store
          .dispatch(Actions.LocationEdit, dispatchData)
          .catch((e) => {
            console.error(Constants.Locations.Messages.Error.Edit, e);
            this.snackbarMessage = Constants.Locations.Messages.Error.Edit;
            this.snackbar = true;
          })
          .finally(() => {
            this.tempDisable = false;
            this.$router.go(-1);
          });
      }
    },
    setup() {
      if (this.userInfo.role !== Constants.Roles.HR) {
        this.$router.go(-1);
        return false;
      }
      this.phoneValidator = libphonenumber.PhoneNumberUtil.getInstance();
      this.tempDisable = false;
      this.getAddress();
    },
    deleteAddress() {
      if (!this.id) return false;
      this.$store
        .dispatch(Actions.LocationDelete, this.$route.params.id)
        .then(() => this.$router.go(-1))
        .catch((e) => {
          console.error(Constants.Locations.Messages.Error.Delete, e);
          this.snackbar = true;
          this.snackbarMessage = Constants.Locations.Messages.Error.Delete;
        })
        .finally(() => (this.dialog = false));
    },
    getAddress() {
      this.$store
        .dispatch(Actions.LocationGet, this.$route.params.id)
        .then((r) => {
          if (r.status === 200) {
            this.location = r.data;
            this.location.contact_isd = this.countries.find(
              (el) => el.dial_code === this.location.contact_isd
            );
          }
        })
        .catch((e) => {
          console.error(Constants.Locations.Messages.Error.Get, e);
          this.snackbar = true;
          this.snackbarMessage = Constants.Locations.Messages.Error.Get;
        });
    },
  },
  created() {
    if (!this.$route.params.id) {
      this.$router.go(-1);
      return false;
    }
    if (this.userInfo && this.userInfo.role) {
      this.setup();
    } else {
      this.$store.dispatch(Actions.Firebase.UserInfo).then(() => this.setup());
    }
  },
};
</script>